import { DashboardScope, DashboardDrilldownFilterType } from '@api/domain/types';
import type { DashboardDrilldownFilter } from '@api/domain/types';
import { DashboardDrilldownScope, DashboardDrilldownTab, DashboardDrilldownType } from '@v2/pages/dashboard/common/types/drilldown';

const DRILLDOWN_TYPES: DashboardDrilldownType[] = [
  DashboardDrilldownScope.Machine,
  DashboardDrilldownScope.Customer,
  DashboardDrilldownScope.Part,
];

export const isValidDashboardDrilldownType = (value: unknown): value is DashboardDrilldownType =>
  typeof value === 'string' && (DRILLDOWN_TYPES as string[]).includes(value);

export const isValidDashboardDrilldownTab = (value: unknown): value is DashboardDrilldownTab =>
  typeof value === 'string' && Object.values(DashboardDrilldownTab).includes(value as DashboardDrilldownTab);

export const isValidDashboardScope = (value: unknown): value is DashboardScope =>
  typeof value === 'string' && Object.values(DashboardScope).includes(value as DashboardScope);

export const DEFAULT_CHILD_SCOPE_BY_DRILLDOWN_TYPE: Record<DashboardDrilldownType, DashboardScope> = {
  [DashboardDrilldownScope.Machine]: DashboardScope.NcFile,
  [DashboardDrilldownScope.Customer]: DashboardScope.Part,
  [DashboardDrilldownScope.Part]: DashboardScope.Machine,
};

export const buildDashboardDrilldownFilter = (drilldownType: DashboardDrilldownType, drilldownId: string): DashboardDrilldownFilter => {
  const id = Number(drilldownId);
  switch (drilldownType) {
    case DashboardDrilldownScope.Machine:
      return { $type: DashboardDrilldownFilterType.Machine, machineId: id } as DashboardDrilldownFilter;
    case DashboardDrilldownScope.Customer:
      return { $type: DashboardDrilldownFilterType.Customer, customerId: id } as DashboardDrilldownFilter;
    case DashboardDrilldownScope.Part:
      return { $type: DashboardDrilldownFilterType.Part, partId: id } as DashboardDrilldownFilter;
  }
};
